export const FACILITY_DISPATCH_TARGET_FACILITY = "facility" as const;
export const FACILITY_DISPATCH_TARGET_CLIENT_FACILITY = "clientFacility" as const;
export const FACILITY_DISPATCH_TARGET_MASTER_FACILITY = "masterFacility" as const;

export type TFacilityDispatchTarget =
  | typeof FACILITY_DISPATCH_TARGET_FACILITY
  | typeof FACILITY_DISPATCH_TARGET_CLIENT_FACILITY
  | typeof FACILITY_DISPATCH_TARGET_MASTER_FACILITY;
